import makeApiRequest from './makeApiCall';

export const MDList = async (data) => {
  return await makeApiRequest(`/search/customer/md`, 'POST', null, data, false);
};

export const getMdExpensesReport = async (data) => {
  return await makeApiRequest(`/mds/expense`, 'POST', null, data, false);
};

export const getMdExpensesReportExport = async (data) => {
  return await makeApiRequest(`/mds/expense/report`, 'POST', null, data, false);
};
